<i18n src="./resources/locales.json"></i18n>
<i18n src="./ecs-stat-detailed-unit/resources/locales.json"></i18n>

<template>
  <section class="main-stats-container">
    <v-expansion-panels ref="statsPanel">
      <v-expansion-panel class="surface">
        <v-expansion-panel-header class="py-0 d-block scroll-shadow" expand-icon="mdi-menu-up">
          <ecs-stats-summary-bar-header />
        </v-expansion-panel-header>
        <v-expansion-panel-content class="stats-expansion-panel-content">
          <div ref="scroller" class="scroller" :style="{ width: scrollerWidth }" @wheel="handleScroll">
            <EcsAgentStatsCard v-if="BUSINESS_PROCESSES_STATS.length" :stats="agentStats" />
            <EcsBpStatsCard
              v-for="businessProcessStats in businessProcessesStats"
              :key="businessProcessStats.businessProcessId"
              :stats="businessProcessStats"
            />
          </div>
        </v-expansion-panel-content>
      </v-expansion-panel>
    </v-expansion-panels>
  </section>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import EcsBpStatsCard from '@/components/ecs-agent-stats/ecs-bp-stats-card/EcsBpStatsCard';
import EcsStatsSummaryBarHeader from '@/components/ecs-agent-stats/ecs-stats-summary-bar-header/EcsStatsSummaryBarHeader';
import EcsAgentStatsCard from '@/components/ecs-agent-stats/ecs-agent-stats-card/EcsAgentStatsCard';
import BusinessProcess from '@/classes/BusinessProcess';

export default {
  name: 'EcsAgentStats',

  components: { EcsBpStatsCard, EcsAgentStatsCard, EcsStatsSummaryBarHeader },

  filters: {
    toFixed(value = 0) {
      return `${Math.round(value * 100)}%`;
    }
  },

  data() {
    return {
      observer: null,
      value: null
    };
  },

  computed: {
    ...mapGetters('AGENT', ['isSupervisorOnly']),

    ...mapGetters('STATS', ['SUPERVISED_BUSINESS_PROCESSES_STATS', 'BUSINESS_PROCESSES_STATS', 'loggedInAgentStats']),

    scrollerWidth() {
      const supervisorWidth = this.isSupervisorOnly && this.$featuresManager.supervisorFeatures.enable ? 0 : 1;
      return `${((this.businessProcessesStats || []).length + supervisorWidth) * 300 + 12}px`;
    },

    businessProcessesStats() {
      if (this.isSupervisorOnly && this.$featuresManager.supervisorFeatures.enable) {
        return [...this.SUPERVISED_BUSINESS_PROCESSES_STATS].sort(BusinessProcess.compare);
      }

      const additionalBpsToDisplay = this.SUPERVISED_BUSINESS_PROCESSES_STATS.filter(({ businessProcessId }) => {
        return !this.BUSINESS_PROCESSES_STATS.find(bp => bp.businessProcessId === businessProcessId);
      });

      return [...this.BUSINESS_PROCESSES_STATS, ...additionalBpsToDisplay].sort(BusinessProcess.compare);
    },

    agentStats() {
      return {
        title: this.$t('myStats'),
        isAgentStatsCard: true,
        ...this.loggedInAgentStats
      };
    }
  },

  mounted() {
    this.updateStats();
  },

  methods: {
    ...mapActions('STATS', ['updateAgentsStats', 'updateBusinessProcessStats']),

    updateStats() {
      this.updateAgentsStats();
      this.updateBusinessProcessStats();
    },

    handleScroll(event) {
      const scrollContainer = this.$refs.scroller.parentElement.parentElement;
      scrollContainer.scrollBy(event.deltaY, 0);
    }
  }
};
</script>

<style src="./global.css" />
<style src="./scoped.css" scoped />
